import React, { Component } from "react";
import styled, { css } from "styled-components";

import Gettext, { withGettext } from "./common/Gettext";

const InputContainer = styled.div`
  position: relative;
  overflow: hidden;
  margin: 10px auto;
  max-width: 220px;

  ${props =>
    props.desktop &&
    css`
    margin: 0px;
    max-width: 100%;`};
`;

const Input = styled.input`
  position: absolute;
  width: 100%;
  height: 38px;
  top: 0px;
  left: 0px;
  margin: 0px;
  padding: 0px;
  z-index: 100%;
  opacity: 0;
  filter: alpha(opacity=0);
  cursor: pointer;
  pointer-events: none;

  ${props =>
    props.desktop &&
    css`
    display: inline-block;
    height: 39px;
  `};
`;

const Label = styled.label`
  display: block;
  border-radius: 8px;
  text-align: center;
  text-decoration: none;
  color: #fff;
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.22);
  box-shadow: inset 0px -2px 0px 0px rgba(0, 0, 0, 0.3),
    inset 0px -3px 0px 0px rgba(255, 255, 255, 0.1);
  font: 700 18px/38px Roboto, Arial, sans-serif;
  cursor: pointer;
  background-color: #706281;
  background: linear-gradient(to bottom, #877c95 0%, #706281 100%);
  z-index: -1;
  @media (max-width: 320px) {
    font-size: 22px;
    line-height: 48px;
    min-width: 220px;
  }
  :hover {
    background-color: #877c95;
    background: linear-gradient(to bottom, #706281 0%, #877c95 100%);
  }

  ${props =>
    props.desktop &&
    css`
    border-radius: 8px;
    text-shadow: none;
    box-shadow: none;
    font-size: 16px;
    line-height: 39px;
  `} ${props =>
      props.offline &&
      css`
    @media (max-width: 320px) {
      font-size: 16px;
      line-height: 39px;
      min-width: 0px;
    }
  `} ${props =>
      props.disabled &&
      css`
    pointer-events: none;
    cursor: default;
    background-color: #aaadbb;
    background: linear-gradient(to bottom, #bbbac9 0%, #aaadbb 100%);
  `};
`;

class PassportScanInput extends Component {
  constructor(props) {
    super(props);

    this.onUpload = this.onUpload.bind(this);
  }

  onUpload() {
    const files = document.querySelector(`#${this.props.id}`).files;
    this.props.onChange(files);
  }

  render() {
    const {
      id,
      desktop,
      offlinePopup,
      disabled
    } = this.props;

    return (
      <InputContainer desktop={desktop}>
        <Label
          desktop={desktop}
          offline={offlinePopup}
          isabled={disabled}
          htmlFor={id}
        >
          <Gettext>Attach</Gettext>
        </Label>
        <Input
          type="file"
          id={id}
          accept="image/jpeg,image/gif,image/png,application/pdf"
          onChange={this.onUpload}
        />
      </InputContainer>
    );
  }
}

export default withGettext(PassportScanInput);



// WEBPACK FOOTER //
// ./src/components/PassportScanInput.js